import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnDestroy,
	OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SNModal } from '@web-services/modal/snModal.interfaces';
import { BrandDetailsInfo } from '@models/brands.model';
import { Subject } from 'rxjs';

@Component({
	selector: 'delete-company-modal',
	template: require('./delete-company.modal.html'),
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteCompanyModalComponent implements SNModal {
	@Input() btnDisabled = false;
	@Input() company: BrandDetailsInfo;

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	onSubmit() {
		this.btnDisabled = true;
		this.modalService.setModalData({
			action: 'DELETE_COMPANY',
			props: this.company
		});
	}

	onDismiss(): void {
		this.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/companies-section/delete-company-modal/delete-company.modal.ts